import { Form } from 'react-bootstrap';
import { Controller, useFormContext } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { format, parseISO } from 'date-fns';

const toDate = value => (value ? parseISO(value) : null);
const toValue = date => (date ? format(date, 'yyyy-MM-dd') : '');

// One field for a start and an end date. The form value is { from, to } as
// yyyy-MM-dd strings ('' when not set). Picking only a start date leaves `to`
// empty, which filters read as "from that day onwards".
export const RHFDateRangePicker = ({
  name,
  label,
  required,
  max = true,
  noOptional,
  className,
  placeholder = 'Any date',
  ...rest
}) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Form.Group className={classNames('d-flex flex-column', className)}>
          {!!label && (
            <Form.Label>
              {label} {required && <span className="text-danger">*</span>}
              {!required && (
                <span className="text-500">{!noOptional && '(optional)'}</span>
              )}
            </Form.Label>
          )}
          <DatePicker
            selectsRange
            startDate={toDate(value?.from)}
            endDate={toDate(value?.to)}
            onChange={([start, end]) =>
              onChange({ from: toValue(start), to: toValue(end) })
            }
            dateFormat="dd/MM/yyyy"
            maxDate={max ? new Date() : undefined}
            placeholderText={placeholder}
            isClearable
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            className="form-control"
            wrapperClassName="w-100"
            autoComplete="off"
            {...rest}
          />

          {error && (
            <Form.Control.Feedback className="d-block" type="invalid">
              {error.message}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      )}
    />
  );
};

RHFDateRangePicker.propTypes = {
  name: propTypes.string,
  label: propTypes.string,
  required: propTypes.bool,
  max: propTypes.bool,
  noOptional: propTypes.bool,
  className: propTypes.string,
  placeholder: propTypes.string
};
